import { getCursorWord } from './get-cursor-word';
export const applySuggestion = (suggestion, inputValue, cursorPosition) => {
    const cursor = cursorPosition !== null && cursorPosition !== void 0 ? cursorPosition : 0;
    const { word, cursorStart, cursorEnd } = getCursorWord(inputValue, cursorPosition);
    const firstSection = inputValue.toString().substring(0, cursorStart);
    const lastSection = inputValue.toString().substring(cursorEnd);
    const newValue = firstSection + suggestion.value + lastSection;
    return {
        newValue,
        cursorPosition: cursorStart + suggestion.value.length,
    };
};
//# sourceMappingURL=apply-suggestion.js.map